import React, { useMemo } from "react";
import { useAppSelector } from "../../../store/hooks";
import { selectDirection, selectTranslatedString } from "../../../store/selectors/appSelectors";
import { DirectionE } from "../../../models/enums";
import { useTranslate } from "../../../utils/hooks/useTranslate";
import { selectCurrentUser } from "../../../store/selectors/authSelectors";
import getUserType from "../helpers/getUserType";

/**
 * Get tour name and CSS selectors list and returns tour's steps
 *
 * @param {string} tourName - tour name
 * @param {Array<string>} elements - list of CSS selectors, which have to be highlighted
 *
 * @returns {Array<Object>}
 * */

const useTour = (tourName, elements) => {
  const isLTRDirection = useAppSelector(selectDirection) === DirectionE.LTR;
  const position = isLTRDirection ? "right" : "left";
  const { t } = useTranslate();
  // Stable reference (changes only when translations actually load/change). useTranslate's `t` is a
  // fresh function every render, so we key the memo on this instead — otherwise the steps array
  // would have a new identity on every render. That identity churn makes intro.js-react's
  // componentDidUpdate re-run configureIntroJs()/renderSteps() constantly, which can re-start() the
  // tour and produce a duplicate step-1 tooltip.
  const translatedStrings = useAppSelector(selectTranslatedString);
  const user = useAppSelector(selectCurrentUser);
  // Stable string key for the selectors list (the array arg is rebuilt by the caller each render).
  const elementsKey = elements.join("|");
  // const userType = useMemo(() => getUserType(user?.clientType), [user?.clientType]);

  // const replacePersonalPageTourTextStep1 = (constKey) => {
  //   if (constKey === "1_tour_page-edit_text") {
  //     //if text includes #PAGEURL#, replace it with the current page url after page-edit/
  //     const pageUrl = window.location.href.split("page-edit/")[1];
  //     const baseUrl = config.baseurl + "/l" + getPath();
  //     let url = baseUrl;

  //     if (pageUrl.includes("?")) {
  //       url = baseUrl + pageUrl.split("?")[0];
  //       let text = getTextByKey(constKey).replaceAll("#PAGEURL#", url);
  //       return (text);
  //     }
  //     url = baseUrl + pageUrl;
  //     let text = getTextByKey(constKey).replaceAll("#PAGEURL#", url);
  //     return (text);
  //   } else {
  //     return getTextByKey(constKey);
  //   }
  // };

  return useMemo(
    () =>
      elements.map((element, index) => ({
        element,
        title: t(`${index + 1} tour ${tourName} title`),
        // intro: replacePersonalPageTourTextStep1(
        //   `${index + 1}_tour_${tourName}_text`
        // ),
        intro: t(`${index + 1} tour ${tourName} text`),
        position: element === ".top-section" ? "left" : position,
        // Generate class selectors like '.tooltip_0_tour_inbox' which you can use within CSS
        tooltipClass: `tooltip_${index + 1}_tour_${tourName}${isLTRDirection ? "" : "_rtl tooltip_element_rtl"
          }`,
        highlightClass: `highlight_${index + 1}_tour_${tourName}${isLTRDirection ? "" : "_rtl"
          }`,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tourName, elementsKey, isLTRDirection, translatedStrings]
  );
};

export default useTour;
